import { render, staticRenderFns } from "./MatchType.vue?vue&type=template&id=2d6c12c0&"
import script from "./MatchType.vue?vue&type=script&lang=js&"
export * from "./MatchType.vue?vue&type=script&lang=js&"
import style0 from "./MatchType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports